@if (nativeLandingPage(); as hero) {
  <div class="fixed left-0 right-0 top-insetTop hero">
    <svg class="wave" viewBox="0 0 1440 80" preserveAspectRatio="none">
      <path d="M0,80 C480,0 960,0 1440,80 L1440,80 L0,80 Z" fill="#ffffff"/>
    </svg>
    <div class="absolute left-1/2 right-1/2 w-[24rem] top-0 bottom-0 -translate-x-1/2">
      @for (image of hero.heroImages; track $index) {
      <img class="absolute rounded-lg"
           [src]="image.src"
           [style]="{
              top: image.position.top,
              left: image.position.left,
              right: image.position.right,
              bottom: image.position.bottom,
              width: image.width,
              height: image.height,
              'aspect-ratio': image.aspectRatio
           }"
           alt=""/>
      }
    </div>
  </div>
  <h1 class="mt-[16rem] text-center text-4xl font-semibold" [innerHTML]="hero.title"></h1>
  <p class="text-center mt-8 font-light mb-2" [innerHTML]="hero.subtitle"></p>
  @if (user(); as user) {
    <a class="mt-auto" pButton [routerLink]="initialSignupRoute">
      @if (user.status === 'unauthorized') {
        {{ hero.buttonText }}
      } @else {
        Continue signing up
      }
    </a>
    @if (user.status === 'unauthorized') {
      <a class="mt-2" pButton severity="secondary" [routerLink]="loginRoute">Already using Homey? Log in</a>
    } @else {
      <p class="text-muted-color text-center mt-2 text-sm">Logged in as {{ user.email }},
        <button class="underline cursor-pointer" (click)="onLogoutClick()">Logout</button>
      </p>
    }
  }
}
